<template>
  <label for="check-acc" class="checkbox not-empty">
    <input
      id="check-acc"
      type="checkbox"
      v-model="checkbox"
      class="checkbox__input not-empty"
    />
    <div class="checkbox__marker form__field-input"></div>
    <div class="checkbox__text">
      <slot>
        מסכים עם חוקי התנהגות בשטח הכפר
        <icon name="permission-tabs__alert" width="16" height="16" />
      </slot>
    </div>
    <!--    <div-->
    <!--      class="form__field-error"-->
    <!--      v-if="!acceptSchoolRules && submitPermit"-->
    <!--    >-->
    <!--      שדה חובה-->
    <!--    </div>-->
  </label>
</template>

<script>
export default {
  name: 'CheckboxField',
  props: {
    value: {
      default: false
    },
    labelText: {},
    error: {},
    errorText: {}
  },
  data() {
    return {
      checkbox: false
    };
  },
  watch: {
    checkbox(val) {
      this.$emit('input', val);
    }
  },
  mounted() {
    this.checkbox = this.value;
  }
};
</script>

<style scoped></style>
